export default {
  API_KEY: process.env.REACT_APP_API_KEY,
  API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT,
  CONTACT_API_ENDPOINT: process.env.REACT_APP_CONTACT_API_ENDPOINT,
  CORS: "https://cors-anywhere.herokuapp.com/",
  MAPS_EMBED_API_KEY: process.env.REACT_APP_MAPS_EMBED_API_KEY,
};
